import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IConfirmationState } from "../interfaces/iconfirmation-status";

export const selectConfirmationState = createFeatureSelector<IConfirmationState>('confirmation');

export const getState = createSelector(selectConfirmationState, (state: IConfirmationState) => state);